import { render, staticRenderFns } from "./NuevoAlmacen.vue?vue&type=template&id=42c96760"
import script from "./NuevoAlmacen.vue?vue&type=script&lang=js"
export * from "./NuevoAlmacen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports